import { request } from '@/utils/request';

const urls = {
  departments: '/zlb/api/pay/bankCard/departments', // 所属部门
  list: '/zlb/api/pay/bankCard/pc/manager', // 列表
  unbundle: '/zlb/api/pay/bankCard/delete', // 解绑
  async: '/zlb/api/pay/bankCard/official/sync', // 同步公务卡
};

export async function reqDepartments () {
  return request(urls.departments);
}

export async function reqList (data) {
  return request(urls.list, {
    method: 'POST',
    data,
  });
}


export async function reqUnbundle (data) {
  return request(`${urls.unbundle}/${data.accountCode}`, {
    method: 'POST',
  });
}

export async function asyncOfficailCard (data) {
  return request(urls.async, {
    method: 'POST',
    data,
  });
}

/**
 * 获取可绑定的公务卡（管理员公务卡管理入口）
 * @param {*} params 
 * @returns 
 */
export async function getBindableOfficialCard (params) {
  return request('/zlb/api/pay/bankCard/official/bindable-accountant', {
    params,
  });
}
/**
 * 获取已绑定公务卡（管理员公务卡管理入口）
 * @param {*} params 
 * @returns 
 */
export async function getBoundOfficialCard (params) {
  return request('/zlb/api/pay/bankCard/official/bound-accountant', {
    params,
  });
}

/**
 * 获取异常的公务卡（管理员公务卡管理入口）
 * @param {*} params 
 * @returns 
 */
export async function getUnavailableOfficialCard (params) {
  return request('/zlb/api/pay/bankCard/official/illegal-accountant', {
    params,
  });
}